import { styled } from '@mui/material/styles';

import { Theme } from '@tgg/ui';

export const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-width: 68.8rem;
    padding: 0 3rem 3rem 3rem;
    margin: 3.1rem auto 0 auto;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        margin-top: 4rem;
    }
`;
